function ModalProvider({ isOpen, children }) {
  return isOpen ? children : null;
}

export default ModalProvider;
